// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListingSwiperPhotos-listPhotoContainer-u91ED {
	position: relative;
	width: 100%;
	height: 100%;
}

.ListingSwiperPhotos-parent-Un9oj {
	padding-top: 66.6667%;
	position: relative;
	height: auto;
}

.ListingSwiperPhotos-imageContent-PMJ2Y {
	position: absolute;
	inset: 0;
	height: 100%;
	width: 100%;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: cover;
	border-radius: 15px;
	background-color: var(--secondary-gray-bg);
}

.ListingSwiperPhotos-sliderItem-DRT2P {
	padding: 1px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Common/ListingSwiperPhotos/ListingSwiperPhotos.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,4BAA4B;CAC5B,sBAAsB;CACtB,mBAAmB;CACnB,0CAA0C;AAC3C;;AAEA;CACC,uBAAuB;AACxB","sourcesContent":[".listPhotoContainer {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.parent {\n\tpadding-top: 66.6667%;\n\tposition: relative;\n\theight: auto;\n}\n\n.imageContent {\n\tposition: absolute;\n\tinset: 0;\n\theight: 100%;\n\twidth: 100%;\n\tbackground-position: 50% 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tborder-radius: 15px;\n\tbackground-color: var(--secondary-gray-bg);\n}\n\n.sliderItem {\n\tpadding: 1px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listPhotoContainer": `ListingSwiperPhotos-listPhotoContainer-u91ED`,
	"parent": `ListingSwiperPhotos-parent-Un9oj`,
	"imageContent": `ListingSwiperPhotos-imageContent-PMJ2Y`,
	"sliderItem": `ListingSwiperPhotos-sliderItem-DRT2P`
};
module.exports = ___CSS_LOADER_EXPORT___;
